import { APICallV2Get } from './APICall';

export class TrashbinListApiCall extends APICallV2Get {
    _method = 'trashbin';
}
